import { render } from "./ReviewUpdateInfo.vue?vue&type=template&id=47f0a762&ts=true"
import script from "./ReviewUpdateInfo.vue?vue&type=script&lang=ts"
export * from "./ReviewUpdateInfo.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__